import "./App.css";
import React, { useEffect } from "react";
import apiConstants from "../src/constants/apiConstants";
import axios from "axios";
import cookie from "react-cookies";
import MainRouter from "./components/routing/MainRouter";
import { useDispatch, useSelector } from "react-redux";
import { setUserToken } from "./components/Redux/Features/userTokenSlice";
import { setUserLogin } from "./components/Redux/Features/userLoginSlice";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";

const App = () => {
  const dispatch = useDispatch();
  const { userId } = useSelector((state) => state.userLogin);
  const cookieUser = cookie.select(/\JWTToken\b/g);
  const userToken = cookieUser.JWTToken;
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        if (!cookieUser || window.location.pathname === "/privacy-policy")
          return;
        dispatch(setUserToken(userToken));

        const req_payload = {};
        const response = await axios.post(
          `${apiConstants.GET_API_URL}getUserDetails`,
          req_payload,
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
            },
          }
        );

        if (response.status === 200) {
          const { userDetails } = response.data;
          dispatch(setUserLogin(userDetails));
        }
      } catch (error) {
        const { statusCode, redirect_url } = error.response.data;
        if (statusCode === 403) {
          window.open(redirect_url, "_self");
        }
      }
    };

    fetchUserDetails();
  }, [userToken]);


  return (
    <div className="App">
      <br />
      {userToken && userId ? (
        <MainRouter />
      ) : window.location.pathname === "/privacy-policy" ? (
        <PrivacyPolicy />
      ) : null}
    </div>
  );
};

export default App;
